import { Injectable } from '@angular/core';
import { HttpService } from '@app/@core/services/http.service';
import { API_ENDPOINTS } from '@app/shared/constants/apiconstants';

@Injectable({
  providedIn: 'root'
})
export class PaymentsService {

  constructor(private httpservice: HttpService) { }

  submitPayment(data: any){
    return this.httpservice.post(API_ENDPOINTS.SUBMITPAYMENT, data);
  }
  Submitnotifiction(data:any){
      return this.httpservice.post(API_ENDPOINTS.notifiction,data);
    }
}
